var exports = {
  "kL": "xfb577c5e--18079c--container",
  "AS": "xfb577c5e--18079c--item",
  "PS": "xfb577c5e--18079c--house",
  "jB": "xfb577c5e--18079c--newbuilding",
};

module.exports = exports;
